var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.1885 5C10.8381 5 7.37751 8.37026 7.37751 12.5C7.37751 16.6772 10.8875 20 15.1885 20C19.4895 20 22.9995 16.6297 22.9995 12.5C23.0489 8.37026 19.4895 5 15.1885 5ZM15.1885 15.3006C13.6065 15.3006 12.2717 14.019 12.2717 12.5C12.2717 10.981 13.6065 9.69937 15.1885 9.69937C16.7704 9.69937 18.1052 10.981 18.1052 12.5C18.1052 14.019 16.8199 15.3006 15.1885 15.3006Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M7.37736 7.18336V18.1011H4.55944L1 7.18336H7.37736Z"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }